import {
  Box,
  ColorOptions,
  convertHexToRGBA,
  Icon,
  Spacer,
  Text,
  TextInputNew,
  TextInputProps,
  TextNew,
} from '@jfs/ui-new'
import * as React from 'react'
import { useCallback, useEffect, useRef, useState } from 'react'
import { TextInput } from 'react-native'
import { emailRegex } from '../../../src/util/regex'
import { RootStore, useStores } from '../../data/store'
import { Colors } from '../../util/util'
import { GridView } from '../GridView'
import { ModBox } from '../ModifiedBox/ModifiedBox'
import { SvgImage } from '../SvgImage'
import { styles } from './styles'

interface Props extends TextInputProps {
  setFieldValue?: any
  fieldName?: string
  label?: string
  title: string
  allValues?: any
  innerRef?: React.RefObject<TextInput>
  value?: any
  testID?: string
  isEmail: boolean
  isTenure?: boolean
  bgColor?: string
  titleColor?: string
  borderColor?: string
  isProducts?: boolean
  hideDelete?: boolean
  isRoi?: boolean
  isLinkedId?: boolean
  badgeWidth?: number
  gridHeight?
  number
}
const TextInputWithDelete = ({
  label,
  setFieldValue,
  fieldName,
  title,
  innerRef,
  allValues,
  value,
  isEmail,
  isTenure = false,
  isRoi = false,
  isProducts = false,
  rightComponent,
  editable = true,
  hideDelete = false,
  error,
  isLinkedId = false,
  badgeWidth = 100,
  gridHeight = 90,
  ...prop
}: Props) => {
  const themedStyle = styles(isEmail)
  const [isFocused, setFocused] = useState(false)
  const [showError, setShowError] = useState(false)
  const [text, setText] = useState('')
  const [values, setValues] = useState<string[]>(value ?? [])
  const [hide, setHide] = useState(false)
  const errorTimerRef = useRef<any>(0)
  const isError = !isFocused && prop.touched && !!error

  const { setMessage } = useStores((store: any) => ({
    setMessage: store.response?.setMessage,
  }))

  useEffect(() => {
    value === undefined && setText('')
    value === undefined && setValues([])
    // if (!value) {
    //   setText('')
    //   setValues([])
    // }
  }, [value])
  useEffect(() => {
    if (setFieldValue && fieldName) {
      if (prop.setValuesOnFieldNameObject) {
        setFieldValue(values)
        // const fieldObject = allValues[fieldName] ?? {}
        // fieldObject[prop.fieldNameObjectKey] = values
        // setFieldValue(fieldName, fieldObject)
      } else {
        setFieldValue(fieldName, values, setFieldValue)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldName, values])

  useEffect(() => {
    if (isError) {
      errorTimerRef.current = setTimeout(() => {
        setShowError(true)
      }, 500)
    } else {
      clearTimeout(errorTimerRef.current)
      setShowError(false)
    }
  }, [isError, text])

  const handleOnchange = (val: string) => {
    setText(val)
    if (prop.setValuesOnFieldNameObject) {
      setFieldValue(values)
    } else {
      setFieldValue(fieldName, values)
    }
  }

  const setValidValue = useCallback(
    (validValue: string) => {
      values.push(validValue)
      setShowError(false)
      setText('')
    },
    [values],
  )

  useEffect(() => {
    if (isProducts || isLinkedId) {
      const regexwithoutComma = isLinkedId ? /[^0-9,A-Za-z_]/g : /[^0-9,A-Za-z]/g
      const txt = text?.replace(regexwithoutComma, '')
      setText(txt)
      if (txt?.includes(',')) {
        const res = txt?.split(',').filter((item) => item !== '')
        const regex = isLinkedId ? /(^$)|(^[a-zA-Z0-9_]+$)/ : /(^$)|(^[a-zA-Z0-9]+$)/
        const items = res?.filter((item: any) => values?.indexOf(item) === -1 && item?.length > 0 && regex.test(item))
        if (items.length > 0) {
          setValues([...values, ...items])
        } else {
          setShowError(true)
        }
        setText('')
      }
      return
    } else if (isRoi) {
      const regex = /^100(\.0{1,2})?$|^([1-9]([0-9])?|0)(\.[0-9]{1,2})?$/
      if (text?.includes(',')) {
        const res = text?.split(',').filter((item) => item !== '')
        const items = res?.filter((item: any) => regex.test(item) && values?.indexOf(item) === -1)
        if (items.length > 0) {
          setValues([...values, ...items])
        } else {
          setShowError(true)
        }
        setText('')
      }
    } else if (isEmail) {
      const regex = new RegExp(emailRegex)
      if (text?.includes(',')) {
        const res = text?.split(',').filter((item) => item !== '')
        const items = res.filter((item: any) => regex.test(item) && values?.indexOf(item) === -1)
        if (items.length > 0) {
          setValues([...values, ...items])
        } else {
          setShowError(true)
        }
        setText('')
      }
    } else if (isTenure) {
      const regex = new RegExp(/^\d{1,2}$/)
      if (text?.includes(',')) {
        const res = text?.split(',').filter((item) => item !== '' && values.indexOf(item + 'M') === -1)
        res.map((item) => {
          if (regex.test(item)) {
            setValidValue(item + 'M')
          }
        })
        // setText('')
      }
    } else {
      const txt = text?.replace(/[^0-9,]/g, '')
      setText(txt)
      if (txt?.includes(',')) {
        const res = txt?.split(',').filter((item) => item !== '')
        if (res?.length === 0) {
          setText('')
        } else {
          const items = res?.filter((item: any) => values?.indexOf(item) === -1 && item?.length > 0)
          if (items?.length === 0) {
            setText('')
          } else {
            items?.map((item) => {
              setValidValue(item)
            })
          }
        }
      }
    }
  }, [isEmail, setValidValue, showError, text, values])

  const getBadgeColor = (val: any) => {
    let bgColor = (prop.bgColor as ColorOptions) ?? ('#0186B01F' as ColorOptions)
    return fieldName === 'bin' && val?.length > 8 ? ('#FF0000CC' as ColorOptions) : bgColor
  }

  const getBadgeTextColor = (val: any) => {
    let bgColor = prop.color ?? 'BLUE'
    return fieldName === 'bin' && val?.length > 8 ? ('WHITE' as ColorOptions) : bgColor
  }

  const copyToClipBoard = () => {
    navigator.clipboard.writeText(values.reduce((data, item) => data + ',' + item))
    setMessage('Copied to clipboard.', 'POSITIVE')
    RootStore.response.setToastType('POSITIVE')
  }

  const clearAll = () => {
    setValues([])
    setText('')
    if (prop.setValuesOnFieldNameObject) {
      setFieldValue([])
      // const fieldObject = allValues[fieldName] ?? {}
      // fieldObject[prop.fieldNameObjectKey] = []
      // setFieldValue(fieldName, fieldObject)
    } else {
      setFieldValue(fieldName, [])
    }
  }
  const onClear = (textValue: string) => {
    const cleanData = values.filter((item) => item !== textValue)
    setValues(cleanData)
    if (cleanData) {
      if (prop.setValuesOnFieldNameObject) {
        setFieldValue(cleanData)
        // const fieldObject = allValues[fieldName] ?? {}
        // fieldObject[prop.fieldNameObjectKey] = cleanData
        //setFieldValue(fieldName, fieldObject)
      } else {
        setFieldValue(fieldName, cleanData)
      }
    }

    return (
      <ModBox
        show={values?.length > 0}
        zIndex={100}
        flexDirection={'row'}
        maxWidth={isEmail || isTenure ? '50%' : '70%'}
        flexWrap={'wrap'}>
        {values &&
          values.map((item: string, index: number) => {
            // setText(text?.replace(item + ',', ''))
            return (
              <ModBox
                key={index}
                show={item?.length > 0}
                flexDirection={'row'}
                paddingHorizontal={8}
                borderWidth={1}
                marginVertical={isEmail ? 0 : isTenure || isLinkedId ? 2 : 4}
                borderRadius={prop.borderRadius ?? 24}
                marginRight={8}
                alignItems={'center'}
                justify={'space-between'}
                borderColor={'GRAY_SHADOW'}
                h={isEmail || isTenure || isLinkedId ? 16 : 24}
                bg={(prop.bgColor as ColorOptions) ?? ('#0186B01F' as ColorOptions)}>
                <Text
                  fontFamily={'jiotype-medium'}
                  fontSize={isEmail || isTenure || isLinkedId ? 10 : 12}
                  color={prop.color ?? 'BLUE'}>
                  {item.trim()}
                </Text>
                <Spacer size={8} direction="horizontal" />
                <Box
                  alignItems="center"
                  underlayColor="TRANSPARENT"
                  testID="clear-input"
                  onPress={() => onClear(item)}
                  disabled={!editable}>
                  <Icon id="CLEAR" size="FONT_SIZE_TINY" color={(prop.color as ColorOptions) ?? 'BLUE'} />
                </Box>
                <Box
                  alignItems="center"
                  underlayColor="TRANSPARENT"
                  testID="clear-input"
                  onPress={() => onClear(item)}
                  disabled={!editable}>
                  <Icon id="CLEAR" size="FONT_SIZE_TINY" color={(prop.color as ColorOptions) ?? 'BLUE'} />
                </Box>
              </ModBox>
            )
          })}
      </ModBox>
    )
  }

  if (hide) {
    return null
  }

  const handleOnBlur = () => {
    if (isEmail) {
      const regex = new RegExp(emailRegex)

      if (regex.test(text)) {
        const res = text?.split(',').filter((item) => item !== '')
        const items = res.filter((item: any) => regex.test(item) && values.indexOf(item) === -1)
        setValues([...values, ...items])
        setText('')
      } else {
        setShowError(values?.length < 1)
      }
    } else if (isTenure) {
      const regex = new RegExp(/^\d{1,2}$/)
      setFocused(false)
      text?.length > 0 &&
        !text.includes(',') &&
        regex.test(text) &&
        values.indexOf(text + 'M') === -1 &&
        setValues([...values, text + 'M'])
    } else {
      const regex = isLinkedId
        ? new RegExp(/(^$)|(^[a-zA-Z0-9_]+$)/)
        : isProducts
        ? new RegExp(/(^$)|(^[a-zA-Z0-9]+$)/)
        : new RegExp(/^[0-9]*$/)
      setFocused(false)
      if (!text.includes(',') && regex.test(text) && values.indexOf(text) === -1 && text?.length > 0) {
        setValidValue(text)
      } else {
        setText('')
      }
    }
  }
  return (
    <>
      <ModBox show={!!title} alignItems="center" flexDirection="row" pt={isTenure || isLinkedId ? 6 : 0}>
        <Text
          title={title}
          fontFamily={prop?.fontFamily ?? 'jiotype-bold'}
          fontSize={12}
          color={(prop.titleColor as ColorOptions) ?? 'BLACK_21'}
        />
        {prop.showToolTipInfo && prop.toolTipInfoComponent && prop.toolTipInfoComponent}
      </ModBox>
      <Spacer direction={'vertical'} size={8} />
      <Box
        borderRadius={4}
        borderWidth={1}
        borderColor={Colors.BORDER_LIGHT_BLUE as ColorOptions}
        bg={'WHITE'}
        width={'100%'}
        underlayColor={'TRANSPARENT'}
        onPress={() => innerRef?.current?.focus()}
        pl={8}
        pv={8}
        // f={1}
        justify={'space-between'}>
        <Box
          nativeID={'dropdown-wrapper'}
          borderBottomWidth={1}
          borderBottomColor={convertHexToRGBA(Colors.BG_BLUE, 40) as ColorOptions}>
          <GridView
            items={values}
            itemMinWidth={badgeWidth}
            renderItem={({ item, index }) => (
              <ModBox
                show={item?.length > 0}
                key={index}
                flexDirection={'row'}
                paddingHorizontal={8}
                borderWidth={1}
                marginVertical={isEmail ? 2 : 4}
                borderRadius={prop.borderRadius ?? 24}
                marginRight={8}
                alignItems={'center'}
                justify={'space-between'}
                borderColor={(prop.valuesBorderColor as ColorOptions) ?? ('GRAY_SHADOW' as ColorOptions)}
                h={24}
                bg={getBadgeColor(item)}>
                <Text fontFamily={'jiotype-medium'} fontSize={12} color={getBadgeTextColor(item)} numberOfLines={1}>
                  {item?.trim()}
                </Text>
                <Spacer size={8} direction="horizontal" />
                <Box
                  alignItems="center"
                  underlayColor="TRANSPARENT"
                  testID="clear-input"
                  onPress={() => onClear(item)}
                  disabled={!editable}>
                  <Icon id="CLEAR" size="FONT_SIZE_TINY" color={getBadgeTextColor(item)} />
                </Box>
              </ModBox>
            )}
            gridHeight={gridHeight}
            rowHeight={30}
          />
        </Box>
        <TextInputNew
          {...themedStyle.textInput}
          innerRef={innerRef}
          placeholder={label}
          onChangeText={handleOnchange}
          touched={true}
          onFocus={() => setFocused(true)}
          onBlur={handleOnBlur}
          value={isFocused ? text : ''}
          numberOfLines={3}
          //leftComponent={leftComp()}
          borderColor={'TRANSPARENT'}
          textWidth={prop?.textWidth ?? 150}
          minHeight={!isEmail && !isTenure && !isRoi && !isLinkedId ? undefined : 24}
          editable={editable}
          hide={!editable}
        />

        {!editable && <Box justify={'center'}>{rightComponent}</Box>}
      </Box>
      <Box flexDirection={'row'}>
        <ModBox
          show={!hideDelete && !isEmail && !isTenure && !isRoi}
          onPress={clearAll}
          testID={'clearAll'}
          disabled={!editable}
          underlayColor="TRANSPARENT"
          p={8}
          marginLeft={8}
          mt={4}
          h={30}
          align={'center'}
          borderRadius={4}
          bg={Colors.BG_BLUE_LIGHT as ColorOptions}>
          <Icon id={'DELETE'} color={Colors.BG_BLUE as ColorOptions} />
        </ModBox>
        <Box
          onPress={copyToClipBoard}
          testID={'copyToClipBoard'}
          disabled={values.length === 0}
          underlayColor="TRANSPARENT"
          p={8}
          marginLeft={8}
          h={30}
          mt={4}
          justifyContent={'center'}
          align={'center'}
          borderRadius={4}
          bg={Colors.BG_BLUE_LIGHT as ColorOptions}>
          <SvgImage imageName={'copy'} width={10} height={10} color={'#2269fc'} />
        </Box>
      </Box>
      {showError && (
        <>
          <TextNew color="ERROR" type="body12">
            {error}
          </TextNew>
        </>
      )}
    </>
  )
}

export { TextInputWithDelete }
